import { NotificationsState } from './state';
import { FILTER_NOTIFICATIONS } from '@/enum/filter-notifications.enum';
import i18n from '@/i18n';
import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { NOTIFICATION_PRIORITY, Recipient } from '@/models/crow/in-app-notification.model';

function sortId(a: any, b: any, state?: any) {
  return state && state.orderby === i18n.t(FILTER_NOTIFICATIONS.OLDER) ? a.id - b.id : b.id - a.id;
}

const priorityOrder = {
  [NOTIFICATION_PRIORITY.COMMON]: 1,
  [NOTIFICATION_PRIORITY.SITUATIONAL]: 2,
  [NOTIFICATION_PRIORITY.IMPORTANT]: 3,
};

function sortByExpiration(a: Recipient, b: Recipient) {
  return (
    new Date(a.inAppNotification.expiration).getTime() -
    new Date(b.inAppNotification.expiration).getTime()
  );
}

function sortByCreatedAt(a: Recipient, b: Recipient) {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}

function sortByPriority(a: Recipient, b: Recipient) {
  return priorityOrder[b.inAppNotification.priority] - priorityOrder[a.inAppNotification.priority];
}

function sortInAppNotifications(a: Recipient, b: Recipient) {
  return sortByPriority(a, b) || sortByExpiration(a, b) || sortByCreatedAt(a, b);
}

const getters: GetterTree<NotificationsState, RootState> = {
  userNotifications: (state: NotificationsState) =>
    Object.keys(state.notifications)
      .map((id) => state.notifications[id])
      .sort((a: any, b: any) => sortId(a, b, state)),
  userFeaturedNotifications: (state: NotificationsState) =>
    Object.keys(state.featuredNotifications)
      .map((id) => state.featuredNotifications[id])
      .sort(sortId),
  isLoadingNotifications: (state: NotificationsState) => state.isLoading,
  notificationToShowToUser: (state: NotificationsState) =>
    Object.keys(state.featuredNotifications)
      .map((id) => state.featuredNotifications[id])
      .filter(
        (recipient: Recipient) =>
          !recipient.viewedAt &&
          recipient.inAppNotification.priority !== NOTIFICATION_PRIORITY.COMMON,
      )
      .sort(sortInAppNotifications)[0],
  blockedUrls: (state: NotificationsState) =>
    Object.keys(state.blockList).map((id) => state.blockList[id]),
  showNotificationsModal: (state: NotificationsState): boolean => state.showNotificationsModal,
};

export default getters;
